import { UserEntity, UserRole } from "@/features/users/type.ts";

export const userTools = {
  role: {
    list: ["admin", "courier", "user", "operator"] as UserRole[],
    toString(role: UserRole): string {
      switch (role) {
        case "admin":
          return "Администратор";
        case "courier":
          return "Курьер";
        case "user":
          return "Пользователь";
        case "operator":
          return "Оператор";
        default:
          return "Не определен";
      }
    },
  },
  type: {
    toString(type: string | null): string {
      switch (type) {
        case "person":
          return "Физлицо";
        case "company":
          return "Юрлицо";
        default:
          return "—";
      }
    },
  },
  // ФИО из отдельных полей: заполнено не у всех, поэтому падаем обратно на name.
  fullName(user: UserEntity): string {
    const parts = [user.lastName, user.firstName, user.middleName]
      .filter(Boolean)
      .join(" ")
      .trim();

    return parts || user.name || "Без имени";
  },
};
